// Branch GraphQL Queries to Get, Create, Update, Delete 

import { useRequestGQLQuery } from "./useGraphQLQuery";

export const GET_BRANCHES_SHORT_BY_NAMESPACE = `branches(where: {object_meta: {_contains: $objectMeta}} order_by: { name: asc }) {
    name
    namespace_id
    code
    object_meta
    reports_to_branch
  }
  `;

export const GQL_BRANCHES_BY_NAMESPACE = `  branches(where: {object_meta: {_contains: $objectMeta}} order_by: { name: asc }) {
  id
  name
  namespace_id
  code
  object_meta
  metadata
  address
  mailing_address
  reports_to_branch
  created_at
  updated_at
}`

export const GET_BRANCHES_BY_NAMESPACE = `query getBranches($objectMeta: jsonb) {
  ${GQL_BRANCHES_BY_NAMESPACE}
}
  `;

  export const CREATE_OR_UPDATE_BRANCHES = `mutation createOrUpdateBranches($data: [branches_insert_input!]!) {
    insert_branches(objects: $data, on_conflict: {constraint: branches_pkey, update_columns: [name, address, mailing_address, metadata, reports_to_branch, code, object_meta, updated_at]}) {
        returning {
          id
          name
          namespace_id
          code
          object_meta
          metadata
          address
          mailing_address
          reports_to_branch
          created_at
          updated_at
        }
      }
    }`


export const DELETE_BRANCH = `mutation deleteBranche($uid: bigint) {
    delete_branches(where: {id: {_eq: $uid} }) {
    affected_rows
    }
  }`


  export const GQLGetBranchesByNamespace = (variables: any) => {
    const result = useRequestGQLQuery(GET_BRANCHES_BY_NAMESPACE, variables);
    return result;
  };


    export const GQLUpsertBranche = (branch: any) => {
    const result = useRequestGQLQuery(CREATE_OR_UPDATE_BRANCHES, {data: [branch]});
    return result;
  };